<template>
  <div class="payment-installments padding-vertical-l flex-row">
    <div class="dropdown-container">
      <div class="ri-font-14 margin-bottom-sm margin-bottom-sm">מספר תשלומים</div>
      <input-dropdown
          :options="installmentOptions"
          :first-selected="firstSelectedOption"
          :on-select="onInstallmentSelect"
          :disabled="selectedOffering.possibleNumberOfInstallments === 1"
          class="installment-dropdown payment-installments-dropdown"
      />
    </div>
    <div class="amount-container" v-if="installmentsCount >= 2">
      <div class="ri-font-14 margin-bottom-s">
        סכום בכל תשלום
      </div>
      <div class="ri-font-20 ri-font-weight-bold margin-top-l">{{ formattedInstallmentsPrice }} ₪</div>
    </div>
  </div>
</template>

<script>

import moneyUtils from '@/utils/money';
import { mapMutations, mapState } from 'vuex';
import _ from 'lodash';
import InputDropdown
  from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/referral-receive-payments/DropdownInput';

export default {
  name: 'PaymentInstallments',
  components: {
    InputDropdown,
  },
  props: {
    price: {
      type: Number,
      required: true,
    },
    paymentDate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('oneOffOfferings', ['selectedOffering', 'installmentsCount']),
    formattedInstallmentsPrice() {
      return moneyUtils.formatAmountWithFraction(this.price / this.installmentsCount, 1);
    },
    installmentOptions() {
      const count = Number(this.selectedOffering.possibleNumberOfInstallments);
      return _.range(1, count + 1).map(num => ({
        label: num.toString(),
        value: num.toString(),
      }));
    },
    firstSelectedOption() {
      return _.find(this.installmentOptions, { value: this.installmentsCount.toString() }) || this.installmentOptions[0];
    },
  },
  methods: {
    ...mapMutations('oneOffOfferings', ['setInstallmentsCount']),
    onInstallmentSelect(option) {
      this.setInstallmentsCount(parseInt(option.value, 10));
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.payment-installments {
  width: 100%;
  text-align: start;

  .dropdown-container {
    flex-grow: 1;
  }

  .installment-dropdown {
    width: 112px;
  }

  .amount-container {
    margin-right: 50px;
    flex-grow: 1;
  }

  .payment-installments-dropdown {
    ::v-deep .vs__dropdown-menu {
      min-width: 112px;
      max-height: 130px;
      position: absolute;
      overflow-y: scroll;
    }
  }

  }
</style>
